import * as Common from '@/tenant/common';

export class PurchaseSummaryReportQuery extends Common.Query {
    constructor(){
        super("PurchaseSummaryReportQuery", null);
    }
    public templateId:number=0;
    public startDate: Date = null;
    public endDate: Date = null;
    public segment: Common.Segment = null;
    public counterpart: Common.Counterpart = null;
    public counterpartCategory: Common.Category = null;
    public commodity: Common.Commodity = null;
    public commodityCategory: Common.Category = null;
    public sort: number = 0;
    public itemCategory: number = 0;
    public summaryCategory1: number = 0;
    public summaryCategory2: number = 0;
    public includeProspect: boolean = false;
    public onExcelExport:boolean = false;           
}

export class PurchaseSummaryReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='PurchaseSummaryReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}